import { lazy } from 'react';

export const ObjectTuneLazy = lazy(() => import('./ObjectTune'));
